import React from 'react';

const RenderPixels=(props)=>{
  return props.pixels.map((item,index)=>{
    if(index===2 || index===5){
      return (
        <div>
        <div onClick={()=>props.manageClick(index)}className="Pixel"key={index}>
          {item}
        </div>
        <br/>
        </div>
      );
    }
    else{
      return (
        <div onClick={()=>props.manageClick(index)}className="Pixel"key={index}>
          {item}
        </div>
      );
    }
  })
}

export default RenderPixels;



// WEBPACK FOOTER //
// ./src/Components/RenderPixels.js